export const loginUser = (data) => {
  localStorage.setItem("mentor_token", data.token);
  localStorage.setItem("mentor_user", JSON.stringify(data));
};

// utils/auth.js

export const getUser = () => {
  const user = localStorage.getItem("mentor_user");
  return user ? JSON.parse(user) : null;
};

export const isLoggedIn = () => {
  return !!localStorage.getItem("mentor_token");
};

export const logoutUser = () => {
  localStorage.removeItem("mentor_token");
  localStorage.removeItem("mentor_user");
};
